import { RepeatingCalendarEventDefinitionModel } from "./RepeatingCalendarEventDefinition.model";

export class RepeatingCalendarEventDefinition extends RepeatingCalendarEventDefinitionModel {}
